/*!
 * recozy – Variantenbild-Synchronisation für Kalles (T4S)
 * ---------------------------------------------------------------------------
 * Ersetzt das fehlerhafte "product-variant-image-fix.js".
 *
 * Verhalten (identisch zu dem, was bei Bay 1 heute sichtbar ist):
 *   - Alle Variantenbilder werden zu EINEM Bildplatz zusammengefasst.
 *   - Beim Farbwechsel wird dort das passende Bild eingesetzt.
 *   - Szenebilder (Bilder ohne Variantenzuordnung) bleiben unveraendert stehen.
 *
 * Wesentlicher Unterschied zur alten Version:
 *   Die Zuordnung Farbe -> Bild wird NICHT mehr aus dem Dateinamen geraten,
 *   sondern aus Shopifys eigener Variantenzuordnung gelesen
 *   (<option data-mdid="..."> im versteckten Varianten-Select).
 *   Sie funktioniert damit unabhaengig davon, wie die Bilddateien heissen.
 *
 * Ausserdem:
 *   - Kein globales Ueberschreiben von Element.prototype.scrollIntoView.
 *   - Kein .remove(): nicht benoetigte Bilder werden mit der theme-eigenen
 *     Klasse "is--media-hide" ausgeblendet und bleiben im DOM.
 */
(function () {
  'use strict';

  var WIDTHS = [200, 400, 600, 800, 1000, 1200, 1400, 1600];

  function mediaIdFromOption(opt) {
    var raw = opt.getAttribute('data-mdid');
    if (!raw) return null;
    raw = raw.replace(/"/g, '').trim();
    return raw && raw !== 'null' && raw !== '0' ? raw : null;
  }

  function buildSrcset(master) {
    if (!master) return '';
    var join = master.indexOf('?') === -1 ? '?' : '&';
    return WIDTHS.map(function (w) {
      return master + join + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  function snapshot(slide) {
    var img = slide.querySelector('img');
    if (!img) return null;
    var wrap = slide.querySelector('.t4s-product__media');
    return {
      master: img.getAttribute('data-master') || '',
      alt: img.getAttribute('alt') || '',
      width: img.getAttribute('width'),
      height: img.getAttribute('height'),
      ratio: wrap ? wrap.style.getPropertyValue('--aspect-ratioapt') : '',
      maxw: wrap ? wrap.style.getPropertyValue('--mw-media') : ''
    };
  }

  function applyTo(slide, data, mediaId) {
    var img = slide.querySelector('img');
    if (!img || !data || !data.master) return;

    slide.setAttribute('data-media-id', mediaId);

    var wrap = slide.querySelector('.t4s-product__media');
    if (wrap) {
      if (data.ratio) wrap.style.setProperty('--aspect-ratioapt', data.ratio);
      if (data.maxw) wrap.style.setProperty('--mw-media', data.maxw);
    }

    img.setAttribute('data-master', data.master);
    img.setAttribute('data-src', data.master);
    if (data.alt) img.setAttribute('alt', data.alt);
    if (data.width) img.setAttribute('width', data.width);
    if (data.height) img.setAttribute('height', data.height);

    // Nur wenn der Lazyloader das Bild bereits ersetzt hat, direkt umschalten.
    // Sonst genuegen die data-Attribute - der Lazyloader uebernimmt.
    var src = img.getAttribute('src') || '';
    if (src.indexOf('data:image') !== 0) {
      img.setAttribute('srcset', buildSrcset(data.master));
      img.setAttribute('src', data.master);
    }
  }

  function setup(scope) {
    var select = scope.querySelector('select[name="id"]');
    var gallery = scope.querySelector('[data-main-media]');
    if (!select || !gallery || gallery.__variantMediaSync) return;

    // 1) Zuordnung aus den Shopify-Variantendaten lesen
    var variantToMedia = {};
    var isVariantMedia = {};
    Array.prototype.forEach.call(select.options, function (opt) {
      var mid = mediaIdFromOption(opt);
      if (!mid) return;
      variantToMedia[String(opt.value)] = mid;
      isVariantMedia[mid] = true;
    });
    if (!Object.keys(variantToMedia).length) return;

    // 2) Variantenbilder in der Galerie finden
    var slides = [].slice.call(gallery.querySelectorAll('[data-main-slide][data-media-id]'));
    var variantSlides = slides.filter(function (el) {
      return isVariantMedia[el.getAttribute('data-media-id')];
    });
    if (variantSlides.length < 2) return; // nichts zusammenzufassen

    // 3) Bilddaten sichern, danach alle bis auf den ersten Platz ausblenden
    var store = {};
    variantSlides.forEach(function (el) {
      var snap = snapshot(el);
      if (snap) store[el.getAttribute('data-media-id')] = snap;
    });

    var slot = variantSlides[0];
    var root = gallery.parentNode || scope;
    variantSlides.slice(1).forEach(function (el) {
      el.classList.add('is--media-hide');
      var mid = el.getAttribute('data-media-id');
      var nav = root.querySelector('.t4s-carousel__nav-item[data-media-id="' + mid + '"]');
      if (nav) nav.classList.add('is--media-hide');
    });

    gallery.__variantMediaSync = true;

    // 4) Beim Variantenwechsel das passende Bild einsetzen
    var current = slot.getAttribute('data-media-id');

    function sync() {
      var target = variantToMedia[String(select.value)];
      if (!target || target === current) return;
      var data = store[target];
      if (!data) return;
      applyTo(slot, data, target);
      current = target;
    }

    // Der Theme-Code feuert 'change' auf diesem Select bei JEDEM
    // Variantenwechsel (Swatch-Klick, Dropdown, ?variant= in der URL).
    select.addEventListener('change', sync);
    sync();
  }

  function boot() {
    var scopes = document.querySelectorAll('[data-product-featured]');
    if (scopes.length) [].forEach.call(scopes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
